import { dayIndex } from './clock';

/*
 * The calendar: weekdays and seasons, which shape demand and weather. Day 0 is a Monday in
 * spring; a season lasts a week of game days, so a year is four weeks.
 */

export const DAYS_PER_SEASON = 7;
/** Saved nowhere (derived from the time), but shown: spring, summer, autumn, winter. */
export const Season = { Spring: 0, Summer: 1, Autumn: 2, Winter: 3 } as const;
export type SeasonId = (typeof Season)[keyof typeof Season];

/** Load factor change (percentage points) by weekday, Monday first: Fridays and Sundays peak. */
const WEEKDAY_LOAD: readonly number[] = [2, -8, -6, 0, 6, -3, 7];
/** Load factor change (percentage points) by season: summer holidays, quiet winters. */
const SEASON_LOAD: readonly number[] = [0, 8, -2, -7];
/** How often airlines make offers (percent) by season. */
const SEASON_OFFERS: readonly number[] = [100, 130, 95, 75];
/** Typical daily mean temperature (°C) by season: the weather drifts towards it. Autumns cool
 * towards the winter, and winters are cold enough that what falls is snow, and it lies. */
export const SEASON_CLIMATE: readonly number[] = [13, 24, 9, -5];

/** 0 = Monday … 6 = Sunday. */
export function weekday(time: number): number {
  return dayIndex(time) % 7;
}

export function season(time: number): SeasonId {
  return (Math.floor(dayIndex(time) / DAYS_PER_SEASON) % 4) as SeasonId;
}

/** Percentage points added to load factors on this day. */
export function loadShift(time: number): number {
  return (WEEKDAY_LOAD[weekday(time)] ?? 0) + (SEASON_LOAD[season(time)] ?? 0);
}

/** Offer frequency in this season (percent). */
export function seasonOffers(time: number): number {
  return SEASON_OFFERS[season(time)] ?? 100;
}
